import React, { useEffect, useState } from "react";
import dataJson from "../data.json";
import { nanoid } from "nanoid";
import bluePaperclip from "../assets/svg/blue-paperclip-icon.svg";
import yellowPaperclip from "../assets/svg/icon-paperclip-in-vertical-position-54717 2.svg";
import arrowRight from "../assets/svg/arrow-right.svg";

const FirstScreen = () => {
  const [data, setData] = useState([]);
  const [activeLines, setActiveLines] = useState([]);

  const setActiveLine = (id) => {
    if (activeLines.includes(id)) {
      setActiveLines(activeLines.filter((el) => el !== id));
    } else {
      setActiveLines([...activeLines, id]);
    }
  };
  useEffect(() => {
    setData(dataJson);
  }, []);

  useEffect(() => {}, [activeLines]);
  return (
    <section className="mainTable">
      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td className="table-number">№</td>
            <td className="table-organization">Организация</td>
            <td>Название банка</td>
            <td className="table-num">Расч. счет</td>
            <td>Основной </td>
            <td>Состояние</td>
            <td className="cell-flex cell-flex-fit">
              <div>
                <img src={bluePaperclip} alt="Clip" />
              </div>
            </td>
            <td>к/с</td>
            <td>Название</td>
            <td>БИК</td>
            <td>Телефон</td>
            <td>Автор записи</td>
            <td>Комментарии</td>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={nanoid()}
              onClick={() => setActiveLine(index + 1)}
              className={activeLines.includes(index + 1) ? "activeLine" : ""}
            >
              <td>
                {index === 0 && <img src={arrowRight} alt="ArrowRightIcon" />}
              </td>
              <td>{index + 1}</td>
              <td>{item.Organization}</td>
              <td>{item.BankName}</td>
              <td>{item.AccountNumber}</td>
              <td>{item.Primary}</td>
              <td>{item.Status}</td>
              <td
                className={`clip-td ${
                  activeLines.includes(index + 1) ? "showClipIcon" : ""
                }`}
              >
                <img
                  src={yellowPaperclip}
                  alt="YellowPaperclip"
                  className="activeLine-paperclip"
                />
              </td>
              <td>{item.CorrespondentAccount}</td>
              <td>{item.Name}</td>
              <td>{item.BIC}</td>
              <td>{item.Phone}</td>
              <td>{item.RecordAuthor}</td>
              <td>{item.Comment}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default FirstScreen;
